module.exports = __webpack_public_path__ + "static/media/lv.2553e491.svg";